<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fG1DFS/tc-custom/9780830873449.jpg?1696024830765" alt="This image is the cover for the book Voices and Views on Paul"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Voices and Views on Paul
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>ECPA Top Shelf Book Cover Award</strong> </p> <p> <strong>In the field of Pauline studies, much has changed over the last twenty years.</strong> Since Ben Witherington III first published his influential book <em>The Paul Quest</em>, monumental works have appeared from scholars such as James D. G. Dunn, N. T. Wright, E. P. Sanders, and John Barclay. The New Perspective is no longer new, and the flurry of publications continues across a range of specialized studies. Those interested in exploring trends and issues related to Paul may find themselves in need of a map.</p> <p>With <em>Voices and Views on Paul</em>, Ben Witherington and Jason Myers have teamed up to provide a reliable guide to the major terrain of Pauline scholarship. Through a distinctive combination of survey and evaluation, they explain and analyze the thought of recent major Pauline interpreters and track developments over the past two decades. They conclude with an assessment of how these studies have advanced our understanding of Paul and where further work is needed.</p> <p> <em>Voices and Views on Paul</em> offers a helpful service to students, pastors, and anyone seeking to keep up with this dynamic field as scholars continue to wrestle with Paul and his work.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ben Witherington III, Jason A. Myers
      </h2>
      
      <p class="authorDescription body article"><p>Ben Witherington III (PhD, University of Durham) is Jean R. Amos Professor of New Testament for Doctoral Studies at Asbury Theological Seminary. He has written over forty books, including <em>The Jesus Quest</em> and <em>The Paul Quest</em>, both of which were selected as top biblical studies works by <em>Christianity Today</em>. His books also include <em>The Indelible Image</em>, <em>Women and the Genesis of Christianity</em>, <em>The Gospel Code</em>, <em>A Week in the Life of Corinth</em>, and commentaries on the entire New Testament.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ec3cdcc4